import { FormControlLabel } from '@material-ui/core';
import * as React from 'react';
import { Views } from '../../../abstract';
import { ProjectViews } from '../../abstract';

interface IDashboardCustomerAddEditViewProps extends Interfaces.IViewProps {
    onSave: () => void
}


class DashboardCustomerAddEditView<P, S> extends ProjectViews.CommonView<P & IDashboardCustomerAddEditViewProps, S> {

    constructor(props: any) {
        super(props);
    }

    public validateForm() {
        const { onSave } = this.props;
        const { model, languageTabValue } = this.state;
        if (model['name'][languageTabValue]) {
            if (model['logo'].ru) {
                if (model['logo']['alt'].ru && model['logo']['alt'].en) {
                    onSave();
                } else {
                    this.setState({ error: 'Заполните описание логотипа на обоих языках!' })
                }
            } else {
                this.setState({ error: 'Загрузите логотип для русского языка!' })
            }
        } else {
            this.setState({ error: 'Заполните наименование!' })
        }
    }

    public renderLeftSide() {
        const { languageTabValue, model } = this.state;
        return (
            <React.Fragment>
                <Views.TextField
                    floatingLabelText="Наименование клиента"
                    fullWidth={true}
                    name="name"
                    value={model['name'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Ссылка на сайт"
                    fullWidth={true}
                    data-field-type="nml"
                    name="url"
                    value={model['url'] ? model['url'] : ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Позиция в списке"
                    fullWidth={true}
                    data-type="number"
                    data-field-type="nml"
                    name="position"
                    // value={model['position'] ? model['position'] : ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <FormControlLabel
                    style={{ alignSelf: 'flex-start', marginTop: 35 }}
                    control={
                        <Views.Switch
                            checked={model['published'] ? true : false}
                            onChange={(e, c) => { model['published'] = c; this.setState({ model }) }}
                            color="black"
                        />
                    }
                    label="Опубликовано"
                />
            </React.Fragment>
        )
    }

    public renderRightSide() {
        const { model, languageTabValue } = this.state;
        return (
            <React.Fragment>
                <Views.Dropzone
                    file={model['logo'][languageTabValue]}
                    onDrop={(files: any) => this.onDropImage(files, 'logo')}
                    multiple={false}
                    onClear={() => this.onDropImage(null, 'logo')}
                    accept="image/*"
                />
                <Views.TextField
                    floatingLabelText="Мета-описание изображения"
                    fullWidth={true}
                    name="logo alt"
                    value={model['logo']['alt'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
            </React.Fragment>
        )
    }
}

export default DashboardCustomerAddEditView;



// WEBPACK FOOTER //
// ./src/app/dashboard/customers/addedit/CustomerAddEditView.tsx